export default __webpack_public_path__ + "static/media/hht1_ep11_timeline_q04_a.e1e9eeef.png";